import { SelectOption } from '@common/types/common';
import { ISubscribersStatus } from '@event/types/event';
import { DateRange, PickersShortcutsItem } from '@mui/x-date-pickers-pro';
import { endOfMonth, endOfWeek, endOfYear, startOfMonth, startOfToday, startOfWeek, startOfYear } from 'date-fns';

const EVENT_AUDIENCE_SEARCH_BY_OPTIONS: SelectOption<string>[] = [
    {
        value: 'name_search',
        label: 'Name',
    },
    {
        value: 'email_search',
        label: 'Email',
    },
    {
        value: 'company_name_search',
        label: 'Company',
    },
];

const COLLEAGUE_HASH_KEY = 'colleague_hash';
const GUEST_ACCESS_HASH_KEY = 'guest_access_hash';

const DEFAULT_EVENT_ANALYTICS: ISubscribersStatus[] = [
    {
        count: 0,
        status: 'accepted',
    },
    { count: 0, status: 'pending' },
    { count: 0, status: 'declined' },
];

const DEFAULT_VIRTUAL_ANALYTICS: ISubscribersStatus[] = [
    {
        count: 0,
        status: 'accepted',
    },
    { count: 0, status: 'declined' },
];

const STATUS_COLORS = {
    accepted: '#13C296',
    pending: '#FFC107',
    able_to_register: '#FFC107',
    declined: '#CD4140',
    canceled: '#CD4140',
};

const UPCOMING_ALERT_MESSAGE =
    'Only upcoming events are displayed here. To view past events, switch to the "Past Events" or "All Events" tab.';
const PAST_ALERT_MESSAGE =
    'Only past events are displayed here. To view upcoming events, switch to the "Upcoming Events" or "All Events" tab.';

const DATE_PICKER_SHORTCUTS: PickersShortcutsItem<DateRange<Date>>[] = [
    {
        label: 'Today',
        getValue: () => {
            const today = startOfToday();

            return [today, today];
        },
    },
    {
        label: 'This week',
        getValue: () => {
            const today = startOfToday();
            const weekStart = startOfWeek(today);
            const weekEnd = endOfWeek(today);

            return [weekStart, weekEnd];
        },
    },
    {
        label: 'This month',
        getValue: () => {
            const today = startOfToday();
            const monthStart = startOfMonth(today);
            const monthEnd = endOfMonth(today);

            return [monthStart, monthEnd];
        },
    },
    {
        label: 'This year',
        getValue: () => {
            const today = startOfToday();
            const yearStart = startOfYear(today);
            const yearEnd = endOfYear(today);

            return [yearStart, yearEnd];
        },
    },
];

const UPCOMING_DATE_PICKER_SHORTCUTS: PickersShortcutsItem<DateRange<Date>>[] = [
    {
        label: 'Today',
        getValue: () => {
            const today = startOfToday();

            return [today, today];
        },
    },
    {
        label: 'This week',
        getValue: () => {
            const today = startOfToday();
            const weekEnd = endOfWeek(today);

            return [today, weekEnd];
        },
    },
    {
        label: 'This month',
        getValue: () => {
            const today = startOfToday();
            const monthEnd = endOfMonth(today);

            return [today, monthEnd];
        },
    },
    {
        label: 'This year',
        getValue: () => {
            const today = startOfToday();
            const yearEnd = endOfYear(today);

            return [today, yearEnd];
        },
    },
];

const PAST_DATE_PICKER_SHORTCUTS: PickersShortcutsItem<DateRange<Date>>[] = [
    {
        label: 'This month',
        getValue: () => {
            const today = startOfToday();
            const monthStart = startOfMonth(today);

            return [monthStart, today];
        },
    },
    {
        label: 'This year',
        getValue: () => {
            const today = startOfToday();
            const yearStart = startOfYear(today);

            return [yearStart, today];
        },
    },
];

const BREAKOUT_ROWS_PER_PAGE_OPTIONS = [
    { label: '5', value: 5 },
    { label: '10', value: 10 },
    { label: '20', value: 20 },
    { label: '50', value: 50 },
    { label: '100', value: 100 },
];

export {
    COLLEAGUE_HASH_KEY,
    DATE_PICKER_SHORTCUTS,
    DEFAULT_EVENT_ANALYTICS,
    DEFAULT_VIRTUAL_ANALYTICS,
    EVENT_AUDIENCE_SEARCH_BY_OPTIONS,
    GUEST_ACCESS_HASH_KEY,
    PAST_ALERT_MESSAGE,
    PAST_DATE_PICKER_SHORTCUTS,
    STATUS_COLORS,
    UPCOMING_ALERT_MESSAGE,
    UPCOMING_DATE_PICKER_SHORTCUTS,
    BREAKOUT_ROWS_PER_PAGE_OPTIONS,
};
